import React from "react";
import type { Title } from "@/hooks/graphql/useTitles";
import { ReactSVG } from "react-svg";

import {
  GameControllerIcon,
  GreyhoundsIcon,
  HarnessRacingIcon,
  HorseRacingIcon,
  QuestionIcon,
  RacingIcon,
  SoccerIcon,
  SportsIcon,
} from "@picklebet/ui";

const titleIconComponents: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  gameController: GameControllerIcon,
  greyhounds: GreyhoundsIcon,
  harnessRacing: HarnessRacingIcon,
  horseRacing: HorseRacingIcon,
  question: QuestionIcon,
  racing: RacingIcon,
  soccer: SoccerIcon,
  sports: SportsIcon,
};

type TitleIconProps = {
  title: Title;
  isActive?: boolean;
  svg?: boolean;
  className?: string;
  inline?: any;
};

export const TitleIcon = ({
  title,
  className,
  ...otherProps
}: TitleIconProps) => {
  if (!title) {
    return null;
  }

  if (title.icon && typeof title.icon === "string") {
    const IconComponent = titleIconComponents[title.icon];
    if (IconComponent) {
      return <IconComponent className={className} />;
    }
    return <QuestionIcon className={className} />;
  } else if (title.icon?.file?.url) {
    return (
      <ReactSVG
        src={title.icon.file.url}
        className={className}
        {...otherProps}
      />
    );
  } else {
    return <QuestionIcon className={className} />;
  }
};
